<template>
  <div ref="container" v-show="visible">
    <div style="margin-bottom:10px">
      <a-button type="primary" @click="returnDetail">返回</a-button>
    </div>
    <!-- <a-modal
        :title="title"
        :width="1600"
        :visible="visible"
        :getContainer="() => $refs.container"
        :maskStyle="{'top':'93px','left':'154px'}"
        :wrapClassName="wrapClassNameInfo()"
        :mask="isDesktop()"
        :maskClosable="false"
        @cancel="handleCancel"
        cancelText="关闭"
        style="top:50px;height: 90%;"> -->
    <template slot="footer">
      <a-button @click="handleCancel">关闭</a-button>
    </template>
    <!-- 产品信息 -->
    <a-card style="margin:0px 0 20px; ">
      <span class="title">产品管理</span>
      <a-form-model ref="form" :model="form">
        <a-row class="form-row" :gutter="24">
          <a-col :span="24 / 3">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品名称">
              <span>{{ productInfo.productName }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="24 / 3">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品规格">
              <span>{{ productInfo.specificationModel }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="24 / 3">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="器械类型">
              <span v-if="productInfo.deviceCategory == 1">器械</span>
              <span v-else-if="productInfo.deviceCategory == 2">体外诊断试剂</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="24 / 3">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="包装级别">
              <span>{{ packageLevel }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="24 / 3">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分类编码">
              <span>{{ productInfo.categoryCode }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="24 / 3">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="码制">
              <span v-if="productInfo.codeSystem == 1">MA</span>
              <span v-else-if="productInfo.codeSystem == 2">GS1</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="24 / 3">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="打印模版">
              <span>{{ printModule }}</span>
              <a class="bindModule" @click="bindModule">绑定</a>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <!-- table区域-begin -->
    <a-table
      bordered
      ref="table"
      size="middle"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      :scroll="{ x: true }"
      :rowKey="
        (record, index) => {
          return index
        }
      "
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, columnWidth: '30px' }"
      @change="handleTableChange"
    >
      <span slot="action" slot-scope="text, record">
        <!-- <a @click="getInfoDetail(record)">生码</a>
              <a-divider type="vertical" /> -->
        <a @click="creatCodeInfo(record)">明细</a>
        <a-divider type="vertical" />
        <!-- <a @click="exports(record)">导出</a> -->
        <a-dropdown>
          <a class="ant-dropdown-link" @click.prevent> 导出 <a-icon type="down" /> </a>
          <a-menu slot="overlay" @click="({ key }) => handleExport(key, record)">
            <a-menu-item key="excel">导出Excel</a-menu-item>
            <a-menu-item key="word">导出TXT</a-menu-item>
          </a-menu>
        </a-dropdown>
        <a-divider type="vertical" />
        <a @click="handlePrint(record)">打印</a>
        <a-divider type="vertical" />
        <a @click="hideInfo(record)">隐藏</a>
      </span>
      <template slot="specCodeSystem" slot-scope="specCodeSystem">
        <span v-if="specCodeSystem === '1'">MA(IDcode)</span>
        <span v-else-if="specCodeSystem === '2'">GS1</span>
        <span v-else-if="specCodeSystem === ''">MA(IDcode)</span>
      </template>
    </a-table>
    <!-- table区域-end -->
    <Print-Model ref="getPrintModule" :specificationId="specificationId" @getModule="getPrintModuleInfo"></Print-Model>
    <PIreorcd ref="PIreorcdref" @ok="modalFormOk" @close="modalFormClose"></PIreorcd>
    <!-- 打印 -->
    <allSelectModel ref="allSelectModelRef" @updateData="handlePrintSuccess"></allSelectModel>

    <!-- </a-modal> -->
  </div>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { mixinDevice } from '@/utils/mixin'
import { queryPiByPage, productPidel, exportPiExcelByPiId, exportPiTxtByPiId } from '@/api/api'
import allSelectModel from './allSelectModel.vue'
import PIreorcd from './PIreorcd'
import Vue from 'vue'
import PrintModel from './printModel.vue'
export default {
  name: 'PIManage',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    PrintModel,
    allSelectModel,
    PIreorcd
  },
  props: {
    productInfo: {
      type: String
    }
  },
  data() {
    return {
      title: 'PI管理',
      visible: false,
      disableMixinCreated: true,
      organLabel: '',
      supplierList: [],
      form: {},
      packageLevel: null,
      queryParam: {
        organId: '',
        number: '',
        materialParam: '',
        type: '',
        subType: '',
        status: ''
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      // 表头
      columns: [
        { title: 'DI编码', dataIndex: 'productDi', width: 120, ellipsis: true },
        { title: '批次号', dataIndex: 'batchNumber', width: 100, ellipsis: true },
        { title: '生产日期', dataIndex: 'startDate', width: 100, ellipsis: true },
        { title: '灭菌批号', dataIndex: 'dbatchNumber', width: 70, ellipsis: true },
        { title: '失效期', dataIndex: 'endDate', width: 100, ellipsis: true },
        { title: '有效期', dataIndex: 'effectiveDate', width: 100, ellipsis: true },
        { title: '序列号长度', dataIndex: 'serialLength', width: 100, ellipsis: true },
        { title: '序列号起', dataIndex: 'serialStartNum', width: 70, ellipsis: true },
        { title: '序列号止', dataIndex: 'serialEndNum', width: 100, ellipsis: true },
        { title: '生码数量', dataIndex: 'codeNum', width: 70, ellipsis: true },
        { title: '未打印', dataIndex: 'notPrintCount', width: 70, ellipsis: true },
        { title: '生码日期', dataIndex: 'createTime', width: 100, ellipsis: true },
        { title: '操作人', dataIndex: 'creatorName', width: 100, ellipsis: true },
        { title: '操作', dataIndex: 'action', width: 200, align: 'center', scopedSlots: { customRender: 'action' } }
      ],
      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30', '50', '100'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      dataSource: [],
      productInfo: {},
      data: {},
      specificationId: null,
      dBatchNumber: '',
      printModule: '',
      printId: '',
      url: {
        list: ''
      }
    }
  },
  created() {},
  methods: {
    // 导出处理
    handleExport(type, record) {
      switch (type) {
        case 'excel':
          this.exportExcel(record)
          break
        case 'word':
          this.exportWord(record)
          break
      }
    },
    // 导出excel
    async exportExcel(record) {
      console.log(record, 'record==============')
      const res = await exportPiExcelByPiId({ id: record.id })
      // 创建 Blob 对象
      const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

      // 创建一个临时的 URL 来表示 Blob 对象
      const url = window.URL.createObjectURL(blob)

      // 创建一个 <a> 元素并模拟点击事件来下载文件
      const a = document.createElement('a')
      a.href = url
      a.download = 'exported_file.xlsx' // 设置下载文件名
      a.click()
      // 释放临时 URL
      window.URL.revokeObjectURL(url)
    },
    async exportWord(record) {
      console.log(record, 'record exportWord==============')
      const res = await exportPiTxtByPiId({ id: record.id })
      // 创建 Blob 对象
      const blob = new Blob([res], { type: 'text/plain' })

      // 创建一个临时的 URL 来表示 Blob 对象
      const url = window.URL.createObjectURL(blob)

      // 创建一个 <a> 元素并模拟点击事件来下载文件
      const a = document.createElement('a')
      a.href = url
      a.download = 'exported_file.txt' // 设置下载文件名
      a.click()
      // 释放临时 URL
      window.URL.revokeObjectURL(url)
    },
    show(record) {
      this.visible = true
      this.data = record
      this.specificationId = record.id
      this.dBatchNumber = record.dBatchNumber
      this.printModule = record.printTemplateName
      this.printId = record.printTemplateId
      this.packageLevel = record.packageLevel
      console.log(record, '管理传过来的值=================')
      this.getQueryPiByPage()
    },
    handlePrintSuccess(detailIdArr) {
      console.log(detailIdArr, '打印成功后返回的id')
      // 精准更新打印次数
      this.getQueryPiByPage()
    },
    returnDetail() {
      this.visible = false
      this.$emit('returnDetail')
    },
    async getQueryPiByPage() {
      this.loading = true
      const params = {
        specificationId: this.specificationId,
        // batchNumber:record.batchNo,
        dBatchNumber: this.dBatchNumber,
        page: this.ipagination.current,
        limit: this.ipagination.pageSize
      }
      const res = await queryPiByPage(params)
      if (res.code === 200 && res.success == true) {
        this.loading = false
        console.log('获取的PI列表===========', res.result)
        console.log(this.ipagination)
        this.ipagination.total = res.result.total
        this.dataSource = res.result.rows
      } else {
        this.loading = false
        this.$message.error(res.message)
      }
    },
     handleTableChange (pagination, filters, sorter) {
      console.log(pagination, 'pagination')
      //分页、排序、筛选变化时触发
      if (pagination && pagination.current) {
        this.ipagination = pagination
        console.log(this.ipagination, 'this.ipagination')
      }
      this.getQueryPiByPage()
    },
    // 删除
    hideInfo(record) {
      this.$confirm('是否删除数据', '确认操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.handleHidePI(record)
        })
        .catch(() => {})
    },
    async handleHidePI(record) {
      const res = await productPidel({ piId: record.id })
      if (res.code === 200 && res.success === true) {
        this.$message({
          type: 'success',
          message: '删除成功'
        })
        this.getQueryPiByPage(this.data)
      } else {
        this.$message({
          type: 'error',
          message: res.message
        })
      }
    },
    // 点击绑定
    bindModule() {
      this.$refs.getPrintModule.show()
    },
    getPrintModuleInfo(e) {
      this.printId = e.uuid
      this.printModule = e.templateName
    },
    // 明细
    creatCodeInfo(record) {
      this.$refs.PIreorcdref.add(record, this.printId)
    },
    // 打印
    handlePrint(record) {
      if (this.printModule) {
        let type = 'Batchprint'
        this.$refs.allSelectModelRef.addStr(record, type, this.printId)
      } else {
        this.$message.error('请先绑定打印模版')
      }
    },
    // 导出
    exports(record) {},
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>

<style scoped>
.title {
  color: #1890ff;
}
.bindModule {
  background: #1890ff;
  color: #fff;
  padding: 6px 10px;
  border-radius: 6px;
  margin-left: 5px;
}
</style>
